import React from 'react'
import styled from 'styled-components'
import {browserHistory} from 'react-router'
import ItemImageList from '../../../finwhale/common/item/image-list'
import getImgUrl from '../../../getImgUrl'
import { cloneDeep } from 'lodash';


const Container = styled.div`
  display: flex;
  font-size: 15px;
  padding: 10px;
  padding-left: 0;
  align-items: center;
  flex-direction: column;
`

const Param = ({name, value, marginLeft, highlighted}) => (
  <div
    style={{
      marginLeft,
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: '80vw',
      marginTop: 20,
      marginBottom: 20,
    }}
  >
    <div style={{display: 'inline-block', width: 165, fontWeight: 800,}}>{name}</div>
    <div
      style={{
        display: 'inline-block',
        lineHeight: 'initial',
        textAlign: 'right',
      }}
    >
      {value}
    </div>
  </div>
)

const A = styled.a`
  display: block;
  font-weight: initial;
  font-size: 1.8em;
  text-align: center;
  text-decoration: none;
  margin-bottom: 40px;
  font-weight: 800;
  ${props => props.isLink && 'color: #0054ff; cursor: pointer; &:hover { color: red; }'}
`

const AutoPartCard = ({href, title, code, data, width, length, execution, weight, agregat, img, children, schemaList, imageList}) => {
  const array = toArray(cloneDeep(data)).sort(obj => Object.values(obj)[0] === code ? -1 : 0);
  
  return (
    <Container>
      <div style={{flexGrow: 0, flexShrink: 1,}}>
        <A
          isLink={href}
          onClick={() => {
            if (href) {
              browserHistory.push(href)
            }
          }}
        >
          {title}
        </A>
        <ItemImageList
          style={{
            maxWidth: '80vw',
          }}
          list={
            (imageList || schemaList)
              ?
              [
                ...(imageList || []).map(e => e ? getImgUrl(`/media/static/product_photos/${e}`) : null),
                ...(schemaList || []).map(e => e ? getImgUrl(`/media/static/schema/${e}`) : null),
              ]
              : [img]
          }
        />
        <div style={{display: 'flex', flexDirection: 'wrap', flexWrap: 'noWrap'}}>
          <div
            style={{
              flex: 1,
            }}
          >
            {
              array.map(e => <Param name={Object.keys(e)[0]} value={e[Object.keys(e)[0]]}/>)
            }
          </div>
        </div>
        {children}
      </div>
    </Container>
  )
}

function toArray(d) {
  let result = [];
  (function recur(data) {
    return data && Object.keys(data).map(param => {
      if (typeof data[param] === 'object') {
        return recur(data[param])
      }
      result.push({[param]: data[param]})
    })
  })(d)
  return result
}

export default AutoPartCard



// WEBPACK FOOTER //
// ./src/finwhale/common/auto-part-card/Mobile.js